import { Ellipsis, Share2, Trash2 } from "lucide-react";
import { toast } from "sonner";

import { SavedSearch } from "@/app/(discover)/jobs/[stateName]/(state-jobs)/components/filters/saved-search-and-preferences/active-selection";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export interface SavedSearchRowButtonDropdownProps {
  search: SavedSearch;
  shareHref: string;
  onDelete: (search: SavedSearch) => void;
}

export const SavedSearchRowButtonDropdown: React.FC<
  SavedSearchRowButtonDropdownProps
> = ({ search, shareHref, onDelete }) => {
  const handleShareClick = () => {
    navigator.clipboard
      .writeText(shareHref)
      .then(() => toast.success("Link copied"))
      .catch(() => toast.error("Could not copy link"));
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="size-6 px-0"
          aria-label="Saved search options"
        >
          <Ellipsis />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56" align="end">
        <DropdownMenuItem
          onSelect={handleShareClick}
          className="cursor-pointer"
        >
          <Share2 />
          Copy share link
        </DropdownMenuItem>
        <DropdownMenuItem
          onSelect={() => onDelete(search)}
          className="cursor-pointer text-destructive"
        >
          <Trash2 />
          Delete saved search
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
